module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_6.f1b0f6f6.png";